const loadListSubscription = {
  action: 'poiList/load',
  routeScreen: 'poiList',
};
const loadRoutesSubscription = 'selectRoutes/load';
const selectedRouteSubscription = {
  action: 'action/selectedIndex',
  routeScreen: 'routes',
};
const loadDetailSubscription = {
  action: 'destinationInformation/load',
  routeScreen: 'destinationInformation',
};

const updateDetailSubscription = 'destinationInformation/update';

const loadRouteWayPointDetails = {
  action: 'routeWaypointDetails/load',
  routeScreen: 'waypoint-details',
};

const loadFavoriteList = {
  action: 'favorites/load',
  routeScreen: 'favorites',
};

const loadRecentList = {
  action: 'recents/load',
  routeScreen: 'recents',
};

const loadQuickLinks = {
  action: 'destinations/load',
  routeScreen: 'destinations',
};

const loadTurnByTurn = {
  action: 'routeDetailsList/load',
  routeScreen: 'fast-route',
};

const loadDialogContinue = {
  action: 'modalDialog/continue',
};

const loadDialogCancel = {
  action: 'modalDialog/cancel',
};

export default {
  loadListSubscription,
  loadDetailSubscription,
  updateDetailSubscription,
  loadRoutesSubscription,
  selectedRouteSubscription,
  loadRouteWayPointDetails,
  loadFavoriteList,
  loadQuickLinks,
  loadTurnByTurn,
  loadRecentList,
  loadDialogContinue,
  loadDialogCancel,
};
